module.exports = __webpack_public_path__ + "static/media/puzzle-ball.2498254c.jpg";